class StickyCta {
  #stickyCta;
  #contactBar;
  #calculators;
  #hideClass = 'ec-sticky-cta--hidden';
  #showClass = 'ec-sticky-cta--shown';

  constructor(stickyCta) {
    this.#stickyCta = stickyCta;
  }

  checkContactBarExists() {
    this.#contactBar = document.querySelector('.contact-bar');
    return this.#contactBar !== null;
  }

  checkIfContactBarIsShown() {
    return !this.#contactBar.classList.contains('ec-fade-out-on-scroll');
  }

  checkCalculatorsExists() {
    this.#calculators = document.querySelectorAll('[data-js-block="calculators"]');
    return this.#calculators.length > 0;
  }

  checkIfCalculatorIsInViewport() {
    let calculatorInViewport = false;

    this.#calculators.forEach((calculator) => {
      const calculatorRect = calculator.getBoundingClientRect();
      const calculatorTop = calculatorRect.top;
      const calculatorBottom = calculatorRect.bottom;

      if (calculatorTop >= 0 && calculatorTop <= window.innerHeight) {
        calculatorInViewport = true;
      } else if (calculatorBottom <= window.innerHeight && calculatorBottom >= 0) {
        calculatorInViewport = true;
      }
    });

    return calculatorInViewport;
  }

  toggleStickyCta(show) {
    if (show) {
      if (this.#stickyCta.classList.contains(this.#hideClass)) {
        this.#stickyCta.classList.remove(this.#hideClass);
      }

      if (!this.#stickyCta.classList.contains(this.#showClass)) {
        this.#stickyCta.classList.add(this.#showClass);
      }
    } else {
      if (!this.#stickyCta.classList.contains(this.#hideClass)) {
        this.#stickyCta.classList.add(this.#hideClass);
      }

      if (this.#stickyCta.classList.contains(this.#showClass)) {
        this.#stickyCta.classList.remove(this.#showClass);
      }
    }
  }

  init() {
    window.addEventListener('scroll', () => {
      if (window.innerWidth < 800) {
        let contactBarIsShown = true;
        let calculatorInViewport = true;

        if (this.checkContactBarExists()) {
          contactBarIsShown = this.checkIfContactBarIsShown();
        } else {
          contactBarIsShown = false;
        }

        if (this.checkCalculatorsExists()) {
          calculatorInViewport = this.checkIfCalculatorIsInViewport();
        } else {
          calculatorInViewport = false;
        }

        if (!contactBarIsShown && !calculatorInViewport) {
          this.toggleStickyCta(true);
        } else {
          this.toggleStickyCta(false);
        }
      }
    });
  }
}

const stickyCtaElement = document.querySelector('[data-js-block="sticky-cta"]');

if (stickyCtaElement !== null) {
  const stickyCtaElementClass = new StickyCta(stickyCtaElement);
  stickyCtaElementClass.init();
}

export default StickyCta;
